import React, { Component } from "react";
import { connect } from "react-redux";


class ClassC000113 extends Component {
  render() {
    return <div>建構中</div>;
  }
}

export default connect((state) => ({ user: state.user }), {})(ClassC000113);